import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Camera, CameraOptions } from '@awesome-cordova-plugins/camera/ngx';
import { Observable, Subject } from 'rxjs';
import { WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { ToastController } from '@ionic/angular';
import domtoimage from 'dom-to-image';
import { jsPDF } from "jspdf";

@Injectable({
   providedIn: 'root',
})
export class ImageService {

   public cameraImage: String;
   // toggle webcam on/off
   public showWebcam = true;
   public allowCameraSwitch = true;
   public multipleWebcamsAvailable = false;
   public deviceId: string;
   public videoOptions: MediaTrackConstraints = {
      // width: {ideal: 1024},
      // height: {ideal: 576}
   };
   public errors: WebcamInitError[] = [];

   // webcam snapshot trigger
   public trigger: Subject<void> = new Subject<void>();
   domtoimage = require('dom-to-image');
   doc = new jsPDF();

   constructor(public http: HttpClient, private _CAMERA: Camera, public toastController: ToastController) {

   }



   takePhotograph() {
      return new Promise(resolve => {
         this._CAMERA.getPicture(
            {
               destinationType: this._CAMERA.DestinationType.DATA_URL,
               targetWidth: 320,
               targetHeight: 240
            })
            .then((data) => {
               this.cameraImage = "data:image/jpeg;base64," + data;
               resolve(this.cameraImage);
            });
      });
   }



   selectPhotograph() {
      return new Promise(resolve => {
         let cameraOptions: CameraOptions = {
            sourceType: this._CAMERA.PictureSourceType.PHOTOLIBRARY,
            destinationType: this._CAMERA.DestinationType.DATA_URL,
            quality: 100,
            targetWidth: 320,
            targetHeight: 240,
            encodingType: this._CAMERA.EncodingType.JPEG,
            correctOrientation: true
         };

         this._CAMERA.getPicture(cameraOptions)
            .then((data) => {
               this.cameraImage = "data:image/jpeg;base64," + data;
               resolve(this.cameraImage);
            });

      });
   }

   public triggerSnapshot(): void {
      this.trigger.next();
   }

   public toggleWebcam(): void {
      this.showWebcam = !this.showWebcam;
   }

   public handleInitError(error: WebcamInitError): void {
      this.errors.push(error);
      this.presentToast('Please enable permission to use your camera', 'toast-danger');
   }


   public cameraWasSwitched(deviceId: string): void {
      console.log('active device: ' + deviceId);
      this.deviceId = deviceId;
   }

   public get triggerObservable(): Observable<void> {
      return this.trigger.asObservable();
   }

   async presentToast(message, type = "toast-success") {
      const toast = await this.toastController.create({
         message: message,
         duration: 4000,
         cssClass: type,
      });
      toast.present();
   }

   generatePDF(id, filename) {
      let node = document.getElementById(id);
      let doc = new jsPDF({ orientation: 'p', format: 'a4' });
      doc.text("Hello world!", 10, 10);
      doc.save(filename + '.pdf');
   }

   downloadPDF(id, filename) {

      let node = document.getElementById(id);

      let img;
      let newImage;


      domtoimage.toPng(node, { bgcolor: '#fff' })

         .then(function (dataUrl) {

            img = new Image();
            img.src = dataUrl;
            newImage = img.src;

            img.onload = function () {

               var pdfWidth = img.width;
               var pdfHeight = img.height;

               // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image

               var doc;

               if (pdfWidth > pdfHeight) {
                  doc = new jsPDF('l', 'px', [pdfWidth, pdfHeight]);
               }
               else {
                  doc = new jsPDF('p', 'px', [pdfWidth, pdfHeight]);
               }


               var width = doc.internal.pageSize.getWidth();
               var height = doc.internal.pageSize.getHeight();


               doc.addImage(newImage, 'PNG', 0, 0, width, height);
               doc.save(filename + '.pdf');

            };


         })
         .catch(function (error) {

            // Error Handling

         });



   }

}